export const CHATKIT_CONFIGS = {
  channel_admin: {
    context: {},
    placeholder: 'Ask me anything about benefits...',
    attachments: { enabled: true, maxCount: 5, maxSize: 10485760 },
    greeting: 'Hello, I\'m Oracle AI Agent. How may I assist you today?',
    prompts: [
      { label: 'What can you do?', prompt: 'What MCP tools and resources do you have available?' },
      { label: 'My information', prompt: 'What information do you have about my person/employee record?' },
      { label: 'New App Support Trax Cases', prompt: 'Show me all new Application Support Trax Cases for this week' }
    ]
  },
  chatkit_oracle: {
    context: {},
    placeholder: 'Ask me anything about benefits...',
    attachments: { enabled: true, maxCount: 5, maxSize: 10485760 },
    greeting: 'Hello, I\'m Oracle AI Agent. How may I assist you today?',
    prompts: [
      { label: 'What can you do?', prompt: 'What MCP tools and resources do you have available?' },
      { label: 'My information', prompt: 'What information do you have about my person/employee record?' },
      { label: 'New App Support Trax Cases', prompt: 'Show me all new Application Support Trax Cases for this week' }
    ]
  },
  chatkit_zoey: {
    context: {},
    placeholder: 'Ask me anything about benefits...',
    attachments: { enabled: true, maxCount: 5, maxSize: 10485760 },
    greeting: 'Hello, I\'m Zoey AI Agent. How may I assist you today?',
    prompts: [
      { label: 'What can you do?', prompt: 'What MCP tools and resources do you have available?' },
      { label: 'My information', prompt: 'What information do you have about my person/employee record?' }
    ]
  },
  chatkit_ruby: {
    context: {},
    placeholder: 'Ask me anything about benefits...',
    attachments: { enabled: true, maxCount: 5, maxSize: 10485760 },
    greeting: 'Hello, I\'m Ruby AI Agent. How may I assist you today?',
    prompts: [
      { label: 'What can you do?', prompt: 'What MCP tools and resources do you have available?' },
      { label: 'My information', prompt: 'What information do you have about my person/employee record?' }
    ]
  },
  employee_import: {
    context: { flow: 'employee_import' }, // preview_id will be added dynamically via data attributes
    placeholder: 'Ask me to review or modify employee records...',
    attachments: { enabled: true, maxCount: 5, maxSize: 10485760 },
    greeting: 'Hello! I can help you review and modify the extracted employee records.',
    prompts: [
      { label: 'Add a new employee', prompt: 'I want to add a new employee to the import' },
      { label: 'Remove duplicate records', prompt: 'Find and remove any duplicate employee records' },
      { label: 'Start the import', prompt: 'I\'m ready to approve and start the import' }
    ]
  }
};
